export enum NotificationType {
	TASK_ADDED = 'TASK_ADDED', // TASK_ADDED
	MODULE_DONE = 'MODULE_DONE', // MODULE_DONE
	TASK_UPDATED = 'TASK_UPDATED', // TASK_UPDATED
	MODULE_ADDED = 'MODULE_ADDED', // MODULE_ADDED
	MODULE_STARTED = 'MODULE_STARTED', // MODULE_STARTED
	DOCUMENT_ADDED = 'DOCUMENT_ADDED', // DOCUMENT_ADDED
	MEETING_REJECT = 'MEETING_REJECT', // MEETING_REJECT
	MEETING_REQUEST = 'MEETING_REQUEST', // MEETING_REQUEST
	MODULE_COMMENTED = 'MODULE_COMMENTED', // MODULE_COMMENTED
	COACH_ASSOCIATION = 'COACH_ASSOCIATION', // COACH_ASSOCIATION
	MEETING_ACCEPTANCE = 'MEETING_ACCEPTANCE', // MEETING_ACCEPTANCE
	MODULE_PUSHES_ADDED = 'MODULE_PUSHES_ADDED', // MODULE_PUSHES_ADDED
	MEETING_ALTERNATIVE = 'MEETING_ALTERNATIVE', // MEETING_ALTERNATIVE
	BASIC_ASSESSMENT_DOCUMENT_GENERATED = 'BASIC_ASSESSMENT_DOCUMENT_GENERATED', // BASIC_ASSESSMENT_DOCUMENT_GENERATED
	DETAILED_ASSESSMENT_DOCUMENT_GENERATED = 'DETAILED_ASSESSMENT_DOCUMENT_GENERATED', //DETAILED_ASSESSMENT_DOCUMENT_GENERATED
}
